import { useDispatch, useSelector } from 'react-redux'
import Dialog from '../../GenericComponents/dialog'
import { useContext, useEffect, useState } from 'react'
import {
    getReportActionsState,
    getVuObjInfoState,
    IActionsOpenState,
    IVuParams,
    setReportActionsState,
} from '../../Redux/VisualUnits/visualUnitStateSlice'
import { useEditSaveVUMutation } from '../../Redux/ReportActions/reportActionsSlice'
import { FoundationsEnums } from '../../enum'
import { setTriggerKey, setTriggerState } from '../../Redux/TriggerApi/triggerApiSlice'
import { FoundationsGenericToaster } from "../../GenericComponents/FoundationsGenericToaster";
import { getMeasureListForVUID } from '../../VisualunitHelpers'
import { FoundationsConstants } from '../../FoundationsConstants'
import { VisualUnitApiDTO_VisualUnit } from '../../Interfaces/APIContracts/VisualUnitApiDTO_VisualUnit'
import { getWorkspaceData } from '../../Redux/Workspace/workspaceSlice'
import {SummaryReportContext} from '../SummaryTiles/Summary'
import { VisualUnitApiDTO_VisualUnit_Extended } from '../../Interfaces/VisualUnit/VisualUnitApiDTO_VisualUnit'
import { useZustandVisualUnitStore } from './vuContext'
import { WorkspaceApiDTO_Workspace } from '../../Interfaces/APIContracts/WorkspaceApiDTO_Workspace'
import { useWorkspaceStore } from '../../Pages/Workspace/workspaceContext'
interface VUSettingsDialogProps {
    isExplore: boolean
    setisExplore: (value: boolean) => void
    report: VisualUnitApiDTO_VisualUnit
    saveVUdataChanges: boolean
    setsaveVUdataChanges: (value: boolean) => void
    editSettingsformData: { [s: string]: any }
    workspaceId: number
    drillThruDPList: any[]
    CheckEditSaveResponse: any
    usersUsingVUs: number
    dashBoardsUsingVUs: number
    roleNames: string[]
    vuParams: IVuParams[]
    setReport: (val: VisualUnitApiDTO_VisualUnit_Extended) => void,
    // setIsRedrawVU? :(value: boolean)=>void,
    setTempVuData: (val: any) => void,
    resetForm? : () => void
    isUpdateFromSettings: React.MutableRefObject<boolean>;
    isSaveClicked: React.MutableRefObject<boolean>;
    actionType?: string;
    setupVU: (value: any) => void;
}

export const VUSettingsDialog = (props: VUSettingsDialogProps) => {
    const dispatch = useDispatch()
    const {
        isExplore,
        setisExplore,
        report,
        saveVUdataChanges,
        setsaveVUdataChanges,
        editSettingsformData,
        workspaceId,
        drillThruDPList,
        CheckEditSaveResponse,
        usersUsingVUs,
        dashBoardsUsingVUs,
        roleNames,
        vuParams,
        resetForm,
        setReport,
        // setIsRedrawVU,
        setTempVuData,      
        isUpdateFromSettings, 
        isSaveClicked,
        actionType,
        setupVU       
    } = props
    const vuObjDataInfoFromStore = useSelector(getVuObjInfoState) // This data is getting used in Metadata Pallette
    let reportsIsOpenState = useSelector(getReportActionsState)
    const [vuObj, setVuObj] = useState(vuObjDataInfoFromStore)
    const [callEditSaveVUAPI] = useEditSaveVUMutation()
    const closePalatte = (vuId: number) => {
        setisExplore(false)
        
    }
     
    const setTableReportAutoRefreshInterval = useZustandVisualUnitStore((s) => s.updateRefreshInterval);
    const currentWorkspaceData: WorkspaceApiDTO_Workspace = useWorkspaceStore((s) => s.workspaceState);
    const bulkUpdateVUs = useWorkspaceStore((s) => s.updateVisualUnits);

    // const SummaryReportContextValues = useContext(SummaryReportContext);
    // const { setSummaryReportAutoRefreshInterval } = SummaryReportContextValues || {};
    
    const findVuParamsById = (id: number) => 
        vuObjDataInfoFromStore.find((itr) => itr.id === report.VisualUnitId);
    const handleEditSaveVU = () => {
        const currentVuParams = findVuParamsById(report.VisualUnitId);
        const measureListForVuId  = getMeasureListForVUID(
            report.VisualUnitId,
            vuObjDataInfoFromStore,
            vuParams,
            vuObj,
            report?.MeasureList,
            setVuObj,
            report
        )
        const currentVU = measureListForVuId?.find((item: any) => item.id === report.VisualUnitId)
        const originalName = currentVuParams?.name || ''; 
        const measureFilterList = isExplore  ? currentVuParams : currentVU
        //if isExplore => 
        //const currentlist = measureFilterList.filter((item: any) => item.id === report.VisualUnitId)
        
        // Fail safe to make sure viewertype is set correctly based on the dimensions and rows - Steven
        let viewerType = report?.ViewerType
        if (measureFilterList?.dimensionRow?.length === 0 &&
            measureFilterList?.dimensionCol?.length === 0){
            viewerType = FoundationsEnums.VisualUnitViewerType.SVU
        } else if (viewerType === FoundationsEnums.VisualUnitViewerType.SVU){
            viewerType = FoundationsEnums.VisualUnitViewerType.Table
        }

        const reqVisualUnitData = {
            id: report.VisualUnitId,
            tempVuId: report.TempVisualUnitId,
            name: editSettingsformData.name !== originalName
                    ? editSettingsformData.name
                    : measureFilterList?.name,
            description: measureFilterList?.description !== '' ? measureFilterList?.description : editSettingsformData.description,
            viewerType: viewerType,
            preview: report?.Preview,
            refreshInterval:
                editSettingsformData.autoRefresh == '' || editSettingsformData.autoRefresh == null
                    ? report.RefreshInterval
                    : editSettingsformData.autoRefresh,
            privacyLock: editSettingsformData.privacyLock,
            allowDrillThru:
                editSettingsformData.allowDrillThru == '' ||
                editSettingsformData.allowDrillThru == null
                    ? report.AllowDrillThru
                    : editSettingsformData.allowDrillThru,
            measures: measureFilterList?.measures,
            filterable: measureFilterList?.filterable,
            dimensionRow: measureFilterList?.dimensionRow || [],
            dimensionCol: measureFilterList?.dimensionCol || [],
            saveChartSwitch: report.ChartSwitch,
            saveChartSettings: report.ChartSettings,
            dashboardName: currentWorkspaceData.Name,
            IsEnabledAutoNavigation: editSettingsformData.autoNext,
            tooltipContent: '',
            DrillthruPageSize: editSettingsformData.drillThruPageSize,
            saveTableSettings: report?.TableSettings || {},
            refinementProfile: report?.refinementProfile,
            callerType: FoundationsConstants.enumVUCallerType.Explore,
            drillthrudp: drillThruDPList, // Converted to JSON
            DrillthruSetMetadatId: CheckEditSaveResponse?.MeasureList[0]?.MetaDataId,
            DashBoardId: workspaceId,            
        }
        //Send form data to API
        if (saveVUdataChanges === true) {
            callEditSaveVUAPI(reqVisualUnitData)
                .then((EditSaveVUResponse: any) => {
                    if (EditSaveVUResponse && EditSaveVUResponse.data.statusCode === 204) {
                        // setIsRedrawVU?.(true)
                        isExplore?
                        isSaveClicked.current = true
                        : isUpdateFromSettings.current = true
                        ; // Set flag before updating
                        // setTempVuData({
                        //     ...report,
                        //     ...EditSaveVUResponse.data.data.vuDetails,
                        // })
                        const newRefreshInterval = EditSaveVUResponse.data.data.vuDetails.RefreshInterval;
                        // if (EditSaveVUResponse?.data?.data?.vuDetails?.XAxisList.length === 0 && EditSaveVUResponse?.data?.data?.vuDetails?.YAxisList.length === 0) {
                        //     setSummaryReportAutoRefreshInterval(newRefreshInterval); // Update context for SummaryReport
                        // }
                        // else{
                            setTableReportAutoRefreshInterval(newRefreshInterval); // Update context for TableReport
                        // }
                        
                        let newList = [...currentWorkspaceData.VisualUnits]
                        newList = newList.map(x => x.VisualUnitId == report.VisualUnitId ?
                                                        EditSaveVUResponse.data.data.vuDetails : x)
                        
                        setupVU(EditSaveVUResponse.data.data.vuDetails) // FP-11897 : For name to get updated in ReportInfo heading
                        bulkUpdateVUs(newList)

//                        setTempVuData((prev: VisualUnitApiDTO_VisualUnit_Extended)=> ({...prev, ...EditSaveVUResponse.data.data.vuDetails})) //FP-11696, Its causing inifinite loop, triggering Use effect inside ReportFrame
                        if (actionType === "addNewVU") {
                            FoundationsGenericToaster("success", "Report Created Successfully");
                        }
                        else {
                            FoundationsGenericToaster("success", "Report Updated Successfully");
                        }                    
                    }
                    else {
                        FoundationsGenericToaster("error", "Sorry, saving report failed. Please try again.");
                    }
                    closePalatte(report.VisualUnitId)
                })
                .catch((error) => {
                    console.error('Error in callEditSaveVUAPI:', error)
                })
            }
            setsaveVUdataChanges(false)
    }
    return (
        <Dialog
            isOpen={saveVUdataChanges}
            onClose={() => setsaveVUdataChanges(!saveVUdataChanges)} // Close dialog on overlay or close button click
            className="ui-front ui-dialog-buttons"
            width={'410px'}
            title="Save Report Changes"
            buttons={[
                {
                  label: "Cancel",
                  id: "cancelSaveVUChanges",
                  onClick: () => {                  
                    setsaveVUdataChanges(!saveVUdataChanges);
                    resetForm?.();
                  },
                  className: "ui-button ui-corner-all ui-widget app-button negative",
                },
                {
                  label: "Save Changes »",
                  id: "saveVUChanges",
                  onClick: handleEditSaveVU,
                  className: "ui-button ui-corner-all ui-widget app-button",
                },
            ]}
        >
            <p>
                Are you sure you want to save the changes to this report?
                <br></br>
            </p>
            <div className="ui-dialog-content ui-widget-content">
                <div className="panel-popup-window">
                    {(usersUsingVUs > 0 || dashBoardsUsingVUs > 0 || roleNames.length > 0) && (
                        <>
                            {usersUsingVUs > 0 && (
                                <p>
                                    This Workspace is currently used by{' '}
                                    <strong>{usersUsingVUs} other user(s)</strong>.<br></br>
                                </p>
                            )}
                            {roleNames.length > 0 && (
                                <>
                                    <p>
                                        This Workspace is currently shared with the following{' '}
                                        <br></br>
                                        <strong>Roles</strong>:
                                    </p>
                                    <ol>
                                        {roleNames.map((role, index) => (
                                            <li key={index}>
                                                <strong>{role}</strong>
                                            </li>
                                        ))}
                                    </ol>
                                </>
                            )}
                            {dashBoardsUsingVUs > 0 && (
                                <p>
                                    This report is currently used in{' '}
                                    <strong>{dashBoardsUsingVUs} workspace(s)</strong>.
                                </p>
                            )}
                            <p>Changes to this report will take effect immediately.</p>
                        </>
                    )}
                </div>
            </div>
        </Dialog>
    )
}
